import styled from "styled-components";

export const Wrapper = styled.div`
    border-bottom: ${globalThis.config.border.small};
    transition: height 2s;
`;

export const NoProjectsWrapper = styled.div`
    padding-left: 100px;
`;
